<template>
  <section class="card _px-md-4 _px-sm-0">
    <div class="card__header _mb-6">
      <slot name="image" />
    </div>
    <div class="card__text">
      <h3 class="_fs-24 _fs-sm-20 _px-md-4 _lh-sm-24 _lh-32 _fw-700 _mb-6">
        <slot name="title"><span v-html="item.title"></span></slot>
      </h3>

      <span class="_fs-20 _px-md-4 _lh-26 card__description">
        <slot name="description"><span v-html="item.description"></span></slot>
      </span>
      <div
        class="_fs-20 _mb-4 _mt-4 _px-md-4 _lh-24 card__speakers"
        v-if="item.speaker"
        v-html="item.speaker"
      ></div>

      <slot name="button" />
    </div>
  </section>
</template>

<script>
export default {
  name: 'SectionCard',
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
}
</script>

<style lang="scss" scoped>
.card {
  cursor: pointer;
  &:hover {
    .card__header img {
      transform: scale(1.05);
    }
  }

  &__header {
    position: relative;
    height: calc(100vw * 0.263);
    min-height: 240px;
    max-height: 320px;
    border: 1px solid color(grey-light);
    border-radius: 16px;
    background-color: color(green-light);
    overflow: hidden;
    width: 100%;

    @media screen and (max-width: 1220px) {
      height: 380px;
      max-height: none;
    }

    @media screen and (max-width: 743px) {
      height: 210px;
    }

    img {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
      transition: all 0.5s ease;
    }
  }

  &__description,
  &__speakers {
    display: block;
    color: color(dark-grey);
  }
}

.card {
  &_large {
    @media screen and (min-width: 1220px) {
      position: relative;
      grid-column-start: 1;
      grid-column-end: 3;
      .card {
        &__text {
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          padding: 24px 64px;
        }
      }
    }
  }

  &_broken {
    @media screen and (min-width: 1220px) {
      position: relative;
      .card {
        &__text {
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;
          padding: 40px;
        }
      }
    }
  }
}
</style>
